// Generated on 4/17/2024, 3:19:37 PM

import { library, dom } from "@fortawesome/fontawesome-svg-core";

import { faBars as faSolidBars } from "@fortawesome/pro-solid-svg-icons/faBars";
import { faCaretDown as faSolidCaretDown } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { faCaretLeft as faSolidCaretLeft } from "@fortawesome/pro-solid-svg-icons/faCaretLeft";
import { faCaretRight as faSolidCaretRight } from "@fortawesome/pro-solid-svg-icons/faCaretRight";
import { faCircleQuestion as faSolidCircleQuestion } from "@fortawesome/pro-solid-svg-icons/faCircleQuestion";
import { faCircleUser as faSolidCircleUser } from "@fortawesome/pro-solid-svg-icons/faCircleUser";
import { faClock as faSolidClock } from "@fortawesome/pro-solid-svg-icons/faClock";
import { faComment as faSolidComment } from "@fortawesome/pro-solid-svg-icons/faComment";
import { faFolder as faSolidFolder } from "@fortawesome/pro-solid-svg-icons/faFolder";
import { faMagnifyingGlass as faSolidMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons/faMagnifyingGlass";
import { faTag as faSolidTag } from "@fortawesome/pro-solid-svg-icons/faTag";
import { faXmark as faSolidXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { faInfoCircle as faSolidInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { faEllipsis as faSolidEllipsis } from "@fortawesome/pro-solid-svg-icons/faEllipsis";
import { faEllipsisVertical as faSolidEllipsisVertical } from "@fortawesome/pro-solid-svg-icons/faEllipsisVertical";

import parseXML from "xml-parse-from-string";

import svgundefined from "../../media/icons/panel-open.svg";

library.add(faSolidBars, faSolidCaretDown, faSolidCaretLeft, faSolidCaretRight, faSolidCircleQuestion, faSolidCircleUser, faSolidClock, faSolidComment, faSolidFolder, faSolidMagnifyingGlass, faSolidTag, faSolidXmark, faSolidInfoCircle, faSolidEllipsis, faSolidEllipsisVertical);

library.add({ "panel-open": { iconName: "panel-open", prefix: "fa-custom", icon: [ svgundefined.attributes.viewBox.split(" ")[2], svgundefined.attributes.viewBox.split(" ")[3], [], "e00b", parseXML(svgundefined.content).firstElementChild.getAttribute("d"), ] }, });

dom.watch();
